import { JoinMeetingResponse } from '@eigtech/meetings-types'
import { useMutation } from '@eigtech/ui-shared-api'
import { toast } from '@eigtech/ui/components/sonner'
import { DeviceLabels, useMeetingManager } from 'amazon-chime-sdk-component-library-react'
import { MeetingSessionConfiguration } from 'amazon-chime-sdk-js'

export function useStartMeetingManager() {
  const meetingManager = useMeetingManager()

  return useMutation({
    async mutationFn(data: JoinMeetingResponse) {
      const meetingSessionConfiguration = new MeetingSessionConfiguration(
        data.chimeMeeting,
        data.chimeAttendee
      )

      await meetingManager.join(meetingSessionConfiguration)
      await meetingManager.start()

      meetingManager.invokeDeviceProvider(DeviceLabels.AudioAndVideo)

      return data
    },
    onSuccess() {
      toast.success('Successfully joined meeting!')
    },
    onError() {
      toast.error('Failed to join meeting. Please try again.')
    },
  })
}
